import React from 'react';
import {
  useCandidateStoriesProcessing,
  useSubmitCandidateStories,
} from '../api/candidateStories/useCandidateStories';

// ECDEX-3840 (slice 5): the story form is a class component wrapped in
// connect/reduxForm, so this adapter reads the submit with hooks and passes it
// down as `submitCandidateStories(values, candidateJwt)` and `processing`.
// Same shape as withCandidateJwt.
export const withCandidateStorySubmission = <P extends { report: any }>(
  Component: React.ComponentType<
    P & {
      submitCandidateStories: (
        values: any,
        jwt?: string | null,
      ) => Promise<unknown>;
      processing: boolean;
    }
  >,
) => {
  const WithCandidateStorySubmission: React.FC<P> = props => {
    const submitCandidateStories = useSubmitCandidateStories(props.report);
    const processing = useCandidateStoriesProcessing(props.report.id);
    return (
      <Component
        {...props}
        submitCandidateStories={submitCandidateStories}
        processing={processing}
      />
    );
  };
  WithCandidateStorySubmission.displayName = `withCandidateStorySubmission(${
    Component.displayName || Component.name || 'Component'
  })`;
  return WithCandidateStorySubmission;
};
